// css =>
import "../../BaseStructure.css";
import Styled from "./locationShow.module.css";

function LocationShow(Props: { pathName: string }) {
    return (
        <div className={`row ${ Styled.PathShowFrame } `}>
            <div className="col-12">
                <h1>{ Props.pathName }</h1>
            </div>
        </div>
    );
}

export default LocationShow;
